<template>
  <div>
    <div class="options">
      <!-- <div class="options_item">
        <span>类型</span>
        <el-radio-group v-model="params.type" size="small" @change="getData(1)">
          <el-radio-button label="0">全部</el-radio-button>
          <el-radio-button label="1">验证码</el-radio-button>
          <el-radio-button label="2">营销短信</el-radio-button>
          <el-radio-button label="3">通知短信</el-radio-button>
        </el-radio-group>
      </div> -->
      <div class="options_item">
        <span>发送状态</span>
        <el-radio-group v-model="params.status" size="small" @change="getData(1)">
          <el-radio-button label="-1">全部</el-radio-button>
          <el-radio-button label="0">未发送</el-radio-button>
          <el-radio-button label="1">发送成功</el-radio-button>
          <el-radio-button label="2">发送失败</el-radio-button>
        </el-radio-group>
      </div>
      <div class="options_item">
        <span>手机号码</span>
        <el-input size="small" class="input_box" v-model="params.mobile" clearable>
          <el-button slot="append" icon="el-icon-search" @click="getData(1)"></el-button>
        </el-input>
      </div>
    </div>
    <div class="page_form">
      <el-table :header-cell-style="setTableHeader" :data="listData">
        <el-table-column label="发送手机号" prop="mobile"></el-table-column>
        <el-table-column label="短信类型" prop="show_type"></el-table-column>
<!--        <el-table-column label="发送内容" prop="content" min-width="100px"></el-table-column>-->
        <el-table-column label="发送时间" prop="show_time"></el-table-column>
        <el-table-column label="发送状态" prop="show_status" width="120px"></el-table-column>
        <!-- <el-table-column label="模板id" prop="template_id" width="80px"></el-table-column> -->
      </el-table>
    </div>
    <div class="page_bottom">
      <el-pagination
        layout="prev, pager, next, total, jumper"
        :current-page="page"
        :total="total"
        :page-size="10"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { SMSSendLogs } from "@/api/set";
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data(){
    return{
      listData: [],
      page: 1, 
      total: 0,
      params: {
        type: 0,
        status: -1,
        mobile: ""
      }, //查询参数
    };
  },
  mounted(){
    this.getData();
  },
  methods:{
    getData(i){
      if(i == 1) {
        this.page = 1;
      }
      var data = {
        token: this.token,
        app_id: this.app_id,
        page: this.page
      }
      if(this.params.type != 0){
        data.type = this.params.type;
      }
      if(this.params.status != -1){
        data.status = this.params.status
      }
      if(this.params.mobile != ""){
        data.mobile = this.params.mobile
      }
      SMSSendLogs(data).then(res => {
        if(res.code == 200){
          this.listData = res.data.data;
          this.total = res.data.total;
          this.listData.forEach(item => {
            // item.show_type = item.type == 1? "验证码":item.type == 2? "营销短信":item.type == 3? "通知短信":""
            item.show_type = "验证码"
            item.show_status = item.status == 0? "未发送":item.status == 1? "发送成功":"发送失败";
            item.show_time = item.send_time == 0? "":this.mydateFormat(item.send_time)
          })
        }
      })
    },
    handleCurrentChange(val){ 
      this.page = val;
      this.getData();
    }
  }
}
</script>
<style lang="scss" scoped>
.bodycontent{
  .options{
    .options_item{
      display: inline-block;
      margin-right: 30px;
      line-height: 50px;
      span{
        margin-right: 12px;
      }
    }
  }
  .page_form{
    margin-top: 20px;
    font-size: 14px;
    border: 1px solid #EBEEF5;
  }
  .page_bottom{
    padding-top: 10px;
  }
  .input_box{
    width: 200px;
  }
}
</style>